import React, { useState } from 'react';
import './css/network.css';
import { Link } from 'react-router-dom';

const Network = ({ numberPhone, combinedData }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div className="fixed-right">
      {combinedData.map(
        (network, idx) =>
          network.icon && (
            <div
              key={idx}
              className={`item ${network.className}  ${open ? 'show' : 'hide'}`}
            >
              <Link to={network.url} title={network.title} target="_blank">
                <img
                  src={network.icon}
                  alt={network.title}
                  className="mw-100"
                />
              </Link>
            </div>
          )
      )}

      <div className={` ${open ? 'border-social' : ''}`}></div>
      <div className="item show toggle-button" onClick={handleToggle}>
        <i className="fas fa-plus"></i>
      </div>

      <div className="item show phone-ring">
        <a
          href={`tel:${numberPhone.value.replace(/[^0-9+]/g, '')}`}
          title={numberPhone.title}
        >
          <img
            src="/images/icons/phone-call-1-300x300.png"
            alt={numberPhone.title}
            className="mw-100"
          />
        </a>
      </div>
    </div>
  );
};

export default Network;
